// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class SetBotPlayerSlotAction implements flatbuffers.IUnpackableObject<SetBotPlayerSlotActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):SetBotPlayerSlotAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsSetBotPlayerSlotAction(bb:flatbuffers.ByteBuffer, obj?:SetBotPlayerSlotAction):SetBotPlayerSlotAction {
  return (obj || new SetBotPlayerSlotAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsSetBotPlayerSlotAction(bb:flatbuffers.ByteBuffer, obj?:SetBotPlayerSlotAction):SetBotPlayerSlotAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new SetBotPlayerSlotAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.LobbySetBotPlayerSlot;
}

playerId():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

static startSetBotPlayerSlotAction(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.LobbySetBotPlayerSlot);
}

static addPlayerId(builder:flatbuffers.Builder, playerId:number) {
  builder.addFieldInt16(1, playerId, 0);
}

static endSetBotPlayerSlotAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createSetBotPlayerSlotAction(builder:flatbuffers.Builder, type:ActionType, playerId:number):flatbuffers.Offset {
  SetBotPlayerSlotAction.startSetBotPlayerSlotAction(builder);
  SetBotPlayerSlotAction.addType(builder, type);
  SetBotPlayerSlotAction.addPlayerId(builder, playerId);
  return SetBotPlayerSlotAction.endSetBotPlayerSlotAction(builder);
}

unpack(): SetBotPlayerSlotActionT {
  return new SetBotPlayerSlotActionT(
    this.type(),
    this.playerId()
  );
}


unpackTo(_o: SetBotPlayerSlotActionT): void {
  _o.type = this.type();
  _o.playerId = this.playerId();
}
}

export class SetBotPlayerSlotActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.LobbySetBotPlayerSlot,
  public playerId: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return SetBotPlayerSlotAction.createSetBotPlayerSlotAction(builder,
    this.type,
    this.playerId
  );
}
}
